// Phase 18 Plan 06 — POLISH-11 High-contrast segmented pill.
//
// Two values: 'normal' / 'high'. Wired to the $contrast persistent atom;
// RootApp mirrors onto documentElement.dataset.contrast. theme.css carries a
// single [data-contrast="high"] override block (WS0b/ARCA-87 collapsed the
// former per-theme variants) that pushes body-text contrast to ≥7:1 per
// UI-SPEC §Color High-contrast overrides.

import { useStore } from '@nanostores/react'
import type { JSX } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { $contrast, type Contrast } from '../../stores/contrast.js'
import { Seg } from '../components/Seg.js'

export function ContrastToggle(): JSX.Element {
  const value = useStore($contrast)
  const intl = useIntl()
  const groupLabel = intl.formatMessage({
    id: 'settings.contrast.label',
    defaultMessage: 'High contrast',
  })
  return (
    <fieldset
      data-testid="contrast-toggle"
      aria-label={groupLabel}
      className="picker-row"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
      }}
    >
      <legend
        style={{
          fontFamily: 'Fredoka, sans-serif',
          fontWeight: 700,
          fontSize: '16px',
          color: 'var(--color-text-primary)',
          padding: 0,
          marginBottom: '4px',
        }}
      >
        <FormattedMessage
          id="settings.contrast.label"
          defaultMessage="High contrast"
        />
      </legend>
      <Seg<Contrast>
        ariaLabel={groupLabel}
        value={value}
        onChange={(next) => $contrast.set(next)}
        options={[
          {
            value: 'normal',
            label: (
              <FormattedMessage
                id="settings.contrast.opt.off"
                defaultMessage="Off"
              />
            ),
          },
          {
            value: 'high',
            label: (
              <FormattedMessage
                id="settings.contrast.opt.on"
                defaultMessage="On"
              />
            ),
          },
        ]}
      />
    </fieldset>
  )
}
